import React from 'react';
import { Link } from 'gatsby';
import ChevronRight from 'assets/icons/chevron-right.svg';
import { classnames } from 'helpers/utils';
import * as styles from './breadcrumbs.module.scss';

type Breadcrumb = {
  name: string
  slug: string
};

type BreadcrumbsProps = {
  breadcrumbs: Breadcrumb[]
  className?: string
};
const Breadcrumbs = ({ breadcrumbs, className = '' }: BreadcrumbsProps) => (
  <div className={classnames(styles.container, className)}>
    {breadcrumbs.map((breadcrumb, index) => (
      <div key={breadcrumb.slug}>
        {index + 1 !== breadcrumbs.length
          ? (
            <Link
              key={breadcrumb.slug}
              to={breadcrumb.slug}
            >
              {breadcrumb.name}
            </Link>
          )
          : (
            <p className={styles.inactive} key={breadcrumb.slug}>
              {breadcrumb.name}
            </p>
          )}

        {index + 1 !== breadcrumbs.length && <ChevronRight className={styles.icon} /> }
      </div>
    ))}
  </div>
);

export { Breadcrumbs };
export type { Breadcrumb };
